<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>包邮促销</span>
				<el-button class="button" @click='edit("")' type="success">新增包邮</el-button>
			</div>
		</template>
		<div class="col">
			<el-table :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据" v-loading="loading" :data="list"
			 style="width: 100%;" :default-sort="sort" border highlight-current-row>
				<el-table-column prop="id" label="编号" sortable width="180">
				</el-table-column>
				<el-table-column prop="subtotal_price" label="当购物车小计价格大于">
				</el-table-column>
				<el-table-column label="分类类型">
					<template #default='scope'>
						<el-tag effect="dark" size='medium' type="success">{{scope.row.get_product_sale_type_name.product_sale_name}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="开始时间">
					<template #default="scope">
						{{timestampToTime(scope.row.start_time)}}
					</template>
				</el-table-column>
				<el-table-column label="结束时间">
					<template #default="scope">
						{{timestampToTime(scope.row.end_time)}}
					</template>
				</el-table-column>
				<el-table-column label="是否包邮开启状态">
					<template #default="scope">
						<el-switch v-model="scope.row.status" active-color="#409EFF" inactive-color="#F56C6C" :active-value="1"
						 :inactive-value="2" @change="changeEnabled(scope.row.status, scope.row.id)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column align="right">
					<template #header>
						<span>操作</span>
					</template>
					<template #default="scope">
						<el-button type="primary" size="medium" @click="edit(scope.row)">编辑</el-button>
						<el-button type="danger" size="medium" @click="destroy(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form label-position='left' :model="item" ref="form" :rules="rules" label-width="170px">
			<el-form-item label="当购物车小计价格大于" prop="subtotal_price">
				<el-input style='width: 350px;' v-model="item.subtotal_price" size="small" placeholder="请输入价格"></el-input>
			</el-form-item>
			<el-form-item label="商品类型" prop="product_sale_type">
				<el-select filterable v-model="item.product_sale_type" clearable placeholder="请选择">
					<el-option v-for="item in all_product_sale_type" :key="item.id" :label="item.product_sale_name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="包邮时间">
				<el-row :gutter="20">
					<el-col :span="10">
						<el-form-item prop="start_time">
							<el-input v-model="item.start_time" type="date" placeholder="开始时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item prop="end_time">
							<el-input v-model="item.end_time" type="date" placeholder="结束时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default{
		name:'CategoryFreeShipping',
		data() {
			return {
				title: '新增包邮',
				dialogFormVisible: false,
				loading:true,
				search: '',
				sort: {
					prop: 'id',
					order: 'descending'
				},
				list:[],
				all_product_sale_type:[],
				item:{
					subtotal_price: '',
					product_sale_type:'',
					start_time: '',
					end_time: '',
				},
				rules: {
					subtotal_price:[{
						required: true,
						message: '请填写价格',
						trigger: 'blur'
					}],
					product_sale_type: [{
						required: true,
						message: '商品类型不能为空',
						trigger: 'change'
					}],
					start_time:[{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time:[{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			edit(row) {
				console.log(row)
				let temp = this.cloneObj(row);
				if (row) {
					this.title = '编辑包邮';
					this.item.subtotal_price = temp.subtotal_price;
					this.item.product_sale_type = temp.product_sale_type;
					this.item.start_time = this.timestampToTime(temp.start_time);
					this.item.end_time = this.timestampToTime(temp.end_time);
					this.item.id = temp.id;
				} else {
					this.resetObj(this.item)
					this.item.subtotal_price = ''   // 去除默认值
					this.item.product_sale_type = ''    // 去除默认值
				}
				this.dialogFormVisible = true;
			
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			changeEnabled(status, id) {
				let select_id = id;
				let change_status = status;
				if (select_id) {
					this.loading = true;
					this.httpPost({
						url: '/admin/promotion/categoryFreeShippingUpdateStatus',
						data: {
							id: select_id,
							status: change_status
						}
					}).then((res) => {
						if (res.code == 1) {
							this.$message.success(res.msg);
							this.loading = false;
						}
					})
				}
			},
			destroy(row) {
				console.log(row.id)
				let id = row.id
				// return false;
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/promotion/categoryFreeShippingDel', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getCategoryFreeShipping();
				})
			},
			submit() {
				// console.log(this.item);
				// return false;
				this.$refs['form'].validate((valid) => {
					if (valid) {
					// console.log(this.item)
					// return false;
						this.httpPost({
							url: '/admin/promotion/categoryFreeShippingUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getProductSaleType();
							this.getCategoryFreeShipping();

						})
			
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			
			},
			getProductSaleType() {
				this.httpPost({
					url: '/admin/product/productSaleTypeList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.all_product_sale_type = temp;
			
				}).catch((err) => {})
			},
			getCategoryFreeShipping(){
				this.httpPost({
					url: '/admin/promotion/categoryFreeShippingList',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.list = temp;
					this.loading = false;
							
				}).catch((err) => {})
			}
		},
		created(){
			this.getProductSaleType();
			this.getCategoryFreeShipping();
		}
	}
</script>

<style>
</style>
